import React from 'react';
import './styles.scss';

const Button = ({ text, type = 'filled', size = 'md', pulse=false }) => (
  <a className={`Button Button--${type} Button--${size} ${pulse ? 'Button--pulse':''}`}>{text}</a>
);

export default Button;
